import axios from 'axios'
import store from '@/store'
import { getAccessToken } from './auth'

// 创建axios的对象
const instance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,  //配置固定域名
    timeout: 60000
})

const instanceWithoutBase = axios.create({
  timeout: 60000
})

const instanceWithoutLogout = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,  //配置固定域名
  timeout: 60000
})

// 请求拦截
// 所有的网络请求都会走这个方法,可以在请求添加自定义内容
instance.interceptors.request.use(
  function (config) {
      config.headers.token = getAccessToken()
      return config
  },
  function (err) {
      return Promise.reject(err)
  }
)

instanceWithoutBase.interceptors.request.use(
  function (config) {
      config.headers.token = getAccessToken()
      return config
  },
  function (err) {
      return Promise.reject(err)
  }
)

instanceWithoutLogout.interceptors.request.use(
  function (config) {
    config.headers.token = getAccessToken()
    return config
  },
  function (err) {
    return Promise.reject(err)
  }
)
  
// 响应拦截
// 此处可以根据服务器返回的状态码做相应的数据
instance.interceptors.response.use(
  function (response) {
      const res = response
      if (shouldLogout(res)) {
        logout()
        return Promise.reject(res)
      }
      return res.data
  },
  function (err) {
    if (shouldLogout(err.response)) {
      logout()
    }
    return Promise.reject(err)
  }
)

instanceWithoutBase.interceptors.response.use(
  function (response) {
    const res = response
    if (shouldLogout(res)) {
      logout()
      return Promise.reject(res)
    }
    return res.data
  },
  function (err) {
    if (shouldLogout(err.response)) {
      logout()
    }
    return Promise.reject(err)
  }
)

function logout() {
  store.dispatch('logout').finally(() => {
    tologinPage()
  })
}

function tologinPage() {
  setTimeout(() => {
    window.location.href = '/'
  }, 200);
}

function shouldLogout(response) {
  if (!response) {
    return false
  }
  if (response.status != 401 && response.code != 401) {
    return false
  }
  if (response && response.config && response.config.url === '/user/logout') {
    return false
  }
  return true
}

export {
    instance as request,
    instanceWithoutBase as requestWithoutBase,
    instanceWithoutLogout as requestWithoutLogout
}